import { TimelineInsightsSyncResponseSchema, TimelineLinkInsightsPayloadSchema } from '@sweetistics/contracts';
import type { z } from 'zod';
import {
  MentionsTimelineResponseSchema,
  ProfileStatusResponseSchema,
  TimelinePageResponseSchema,
  TimelineSnapshotResponseSchema,
  UserAnalysisCacheResponseSchema,
  UserStatusResponseSchema,
} from './schemas';

export type TimelinePageResponseInput = z.input<typeof TimelinePageResponseSchema>;
export type TimelinePageResponseOutput = z.output<typeof TimelinePageResponseSchema>;

export function serializeTimelinePageResponse(payload: TimelinePageResponseInput): TimelinePageResponseOutput {
  return TimelinePageResponseSchema.parse(payload);
}

export type MentionsTimelineResponseInput = z.input<typeof MentionsTimelineResponseSchema>;
export type MentionsTimelineResponseOutput = z.output<typeof MentionsTimelineResponseSchema>;

export function serializeMentionsTimelineResponse(
  payload: MentionsTimelineResponseInput
): MentionsTimelineResponseOutput {
  return MentionsTimelineResponseSchema.parse(payload);
}

export type UserAnalysisCacheResponseInput = z.input<typeof UserAnalysisCacheResponseSchema>;
export type UserAnalysisCacheResponseOutput = z.output<typeof UserAnalysisCacheResponseSchema>;

export function serializeUserAnalysisCacheResponse(
  payload: UserAnalysisCacheResponseInput
): UserAnalysisCacheResponseOutput {
  return UserAnalysisCacheResponseSchema.parse(payload);
}

export type TimelineSnapshotResponseInput = z.input<typeof TimelineSnapshotResponseSchema>;
export type TimelineSnapshotResponseOutput = z.output<typeof TimelineSnapshotResponseSchema>;

export function serializeTimelineSnapshotResponse(
  payload: TimelineSnapshotResponseInput
): TimelineSnapshotResponseOutput {
  return TimelineSnapshotResponseSchema.parse(payload);
}

export type UserStatusResponseInput = z.input<typeof UserStatusResponseSchema>;
export type UserStatusResponseOutput = z.output<typeof UserStatusResponseSchema>;

export function serializeUserStatusResponse(payload: UserStatusResponseInput): UserStatusResponseOutput {
  return UserStatusResponseSchema.parse(payload);
}

export type ProfileStatusResponseInput = z.input<typeof ProfileStatusResponseSchema>;
export type ProfileStatusResponseOutput = z.output<typeof ProfileStatusResponseSchema>;

export function serializeProfileStatusResponse(payload: ProfileStatusResponseInput): ProfileStatusResponseOutput {
  return ProfileStatusResponseSchema.parse(payload);
}

export type TimelineLinkInsightsPayloadInput = z.input<typeof TimelineLinkInsightsPayloadSchema>;
export type TimelineLinkInsightsPayloadOutput = z.output<typeof TimelineLinkInsightsPayloadSchema>;

export function serializeTimelineLinkInsightsResponse(
  payload: TimelineLinkInsightsPayloadInput
): TimelineLinkInsightsPayloadOutput {
  return TimelineLinkInsightsPayloadSchema.parse(payload);
}

export type TimelineInsightsSyncResponseInput = z.input<typeof TimelineInsightsSyncResponseSchema>;
export type TimelineInsightsSyncResponseOutput = z.output<typeof TimelineInsightsSyncResponseSchema>;

export function serializeTimelineInsightsSyncResponse(
  payload: TimelineInsightsSyncResponseInput
): TimelineInsightsSyncResponseOutput {
  return TimelineInsightsSyncResponseSchema.parse(payload);
}
